import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import styles from './InformationModal.css';

class InformationModal extends Component {
  render() {
    const { onClose } = this.props;
    return (
      <Modal
        show
        dialogClassName={`${styles.dialog} ${
          styles['info-modal-wrapper']
        } modal-dialog`}
        onHide={onClose}
      >
        <Modal.Body>
          <div>
            <h3 className={`text-center ${styles['no-mtop']}`}>Information</h3>
            <p className="text-center">
              COGS adjustment happens when you create a Purchase Order, Refund
              or have an Incoming Transfer for an item that previously had
              negative inventory.
            </p>
            <a
              onClick={onClose}
              className={`btn btn-default btn-block btn-sm ${
                styles['blue-button']
              }`}
            >
              <strong>OK</strong>
            </a>
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

export default InformationModal;
